import React, { useEffect, useState } from "react";
import { Header, DefaultSideBar } from "components";
import { deleteOneReport, reportingsData } from "services/report";
import TableCreateBatch from "components/TableCreateBatch";
import { useLocation } from 'react-router-dom';
import DefaultModal from "components/DefaultModal";
import * as loader from "../../components/Loading/loading";

export default function ListReport() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get('id');

  const [data, setData] = useState(null);
  const [selectedMaturity, setSelectedMaturity] = useState('');
  const [selectedFinancing, setSelectedFinancing] = useState('');
  const [maxValue, setMaxValue] = useState('');
  const [selectedRefNo, setSelectedRefNo] = useState('');
  const [isOpenConfirmDel, setIsOpenConfirmDel] = useState(false);

  const fetchData = async () => {
    try {
      const reportsData = await reportingsData(id, "", maxValue, selectedMaturity, "", "", selectedFinancing, "");
      setData(reportsData.data);
    } catch (error) {
      console.error("Error fetching reporting data:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedMaturity, selectedFinancing, maxValue]);

  const handleMaturityChange = (criteria) => {
    setSelectedMaturity(criteria.value);
  };

  const handleFinancingChange = (criteria) => {
    setSelectedFinancing(criteria.value);
  };

  const handleMaxValueChange = (criteria) => {
    setMaxValue(criteria);
  };

  const _onClickDelItem = async (refNo) => {
    setSelectedRefNo(refNo)
    setIsOpenConfirmDel(true)
  }

  const _handleDeleteReport = async () => {
    loader.showLoader();
    try {
      const successDelete = await deleteOneReport(selectedRefNo);
      setIsOpenConfirmDel(false);
      if (successDelete) {
        window.location.reload();
      }
    } catch (error) {
      console.error("Error fetching report data:", error);
    } finally {
      loader.hideLoader();
    }
  }

  return (
    <div className=" w-full relative bg-gray-100 pl-[81px] pt-[10vh]">
      <Header />
      <DefaultSideBar />
      <DefaultModal
        isOpen={isOpenConfirmDel}
        type="attention"
        title="Attention"
        desc="Are you sure you want to delete the report?"
        onNoButtonClick={() => setIsOpenConfirmDel(false)}
        onYesButtonClick={_handleDeleteReport}
      />
      {data ? (
        <div className="flex flex-col items-start justify-start w-full mt-5 gap-[17px] px-10">
          <TableCreateBatch
            data={data.reportings}
            onFinancingChange={handleFinancingChange}
            onMaturityChange={handleMaturityChange}
            onMaxValueChange={handleMaxValueChange}
            allowSelection={false}
            allowDeleteItem={true}
            onClickDelItem={_onClickDelItem}
          />
        </div>
      ) : (
        <div className="flex w-full h-[90vh] justify-center items-center">Loading...</div>
      )}
    </div>
  );
}
